module.exports = __webpack_public_path__ + "img/ticket_status02.f090d4ad.png";